import * as ThemeCart from "@shopify/theme-cart"
import CartInput from "./cart-input"
import { disable, enable, generateLineItemPropertyFromValue } from "./helpers"
import { fqa } from "./liquidInit"
import { getLocalStorageCart, updateCartLocalStorage } from "./localstorage"

const formSelector = "form[action='/cart']"
const updateSelectors = "button[name=update], input[name=update]"
const checkoutSelectors = "button[name=checkout], input[name=checkout]"
const buttonSelectors = `${updateSelectors}, ${checkoutSelectors}`

const queue = []

const updateItem = (update) => {
  const { key, quantity, properties, nextLocation, callback } = update
  ThemeCart.updateItem(key, {
    quantity,
    properties,
  }).then((cart) => {
    callback(cart, nextLocation)
  })
}

const updateNote = (update) => {
  const { note, nextLocation, callback } = update
  ThemeCart.updateNote(note).then((cart) => {
    callback(cart, nextLocation)
  })
}

const reload = () => {
  window.location.reload()
}

const goToCheckout = () => {
  document.location.href = "/checkout"
}

const moveAlong = (cart, nextLocation) => {
  if (queue.length) {
    document.dispatchEvent(new CustomEvent("onAjaxStart"))
    const request = queue.shift()
    if (typeof request.note !== "undefined") {
      updateNote(request)
    } else {
      updateItem(request)
    }
  } else {
    // FQAjax Queue is Empty

    document.dispatchEvent(new CustomEvent("onAjaxEnd"))

    if (cart) {
      updateCartLocalStorage(cart)
    }

    if (nextLocation === "checkout") {
      goToCheckout()
    }

    if (nextLocation === "reload") {
      reload()
    }

    if (nextLocation === "silent") {
      // NOTICE - To run silent updates you must include fqa_properties on the cart page to "Spoof" the Line Item Properties.
      document.dispatchEvent(new CustomEvent("onAjaxEnd"))
    }
  }
}

const pushNoteToQueue = (note, nextLocation, callback) => {
  queue.push({
    note,
    nextLocation,
    callback,
  })
}

const pushItemToQueue = (update, nextLocation, callback) => {
  const { key, quantity, properties } = update
  queue.push({
    key,
    quantity,
    properties,
    nextLocation,
    callback,
  })
}

const getItemsFrom = (form) => form.querySelectorAll(`input[name="updates[]"]`)

const getNoteFrom = (form) => {
  if (typeof form.note !== "undefined") {
    return form.note.value
  }
  return ""
}

const getNonFractionalChanges = (element, localItem) => {
  const quantity = parseInt(element.value, 10)
  const localQuantity = parseInt(localItem.quantity, 10)

  if (localQuantity !== quantity) {
    return {
      key: localItem.key,
      quantity,
    }
  }
  return false
}

const getContainerChange = (element, localItem) => {
  const container = element.parentElement
  let quantity = parseInt(element.value, 10)

  const { multiplier, shopifyMaximumQuantity } = CartInput.getDataFrom(
    container
  )

  if (quantity >= shopifyMaximumQuantity) {
    quantity = shopifyMaximumQuantity
  }

  const localQuantity = parseInt(localItem.quantity, 10)
  const localLineItemProps = localItem.properties
  const correctLineItemProps = generateLineItemPropertyFromValue(
    quantity / multiplier
  )

  if (
    localQuantity !== quantity ||
    localLineItemProps["Cut Length"] !== correctLineItemProps
  ) {
    localLineItemProps["Cut Length"] = correctLineItemProps
    return {
      key: localItem.key,
      quantity,
      properties: localLineItemProps,
    }
  }
  return null
}

const checkForUpdates = (items, note, nextLocation) => {
  let hasUpdates = false
  const localStorageCart = getLocalStorageCart()
  const localStorageCartItems = localStorageCart.items
  if (items.length !== localStorageCartItems.length) {
    if (
      // eslint-disable-next-line no-alert
      window.confirm(
        'This cart is out of date with your most recent changes. Click "Ok" to reload the page.'
      )
    ) {
      reload()
    }
    return "cancel"
  }
  const itemDictionary = {}
  localStorageCartItems.forEach((item, index) => {
    if (itemDictionary[item.variant_id] && index !== 0) {
      console.error("We have a duplicate")
    } else {
      itemDictionary[item.variant_id] = item
    }
  })

  items.forEach((element, index) => {
    const localItem = localStorageCartItems[index]
    console.log(localItem)
    if (fqa.product[localItem.product_type]) {
      const change = getContainerChange(element, localItem)
      if (change) {
        hasUpdates = true
        pushItemToQueue(change, nextLocation, moveAlong)
      }
    } else {
      const change = getNonFractionalChanges(element, localItem)
      if (change) {
        hasUpdates = true
        pushItemToQueue(change, nextLocation, moveAlong)
      }
    }
  })

  if (note !== localStorageCart.note) {
    hasUpdates = true
    pushNoteToQueue(note, nextLocation, moveAlong)
  }

  return hasUpdates
}

const checkItemProperties = (item) => {
  if (fqa.product[item.product_type]) {
    const { multiplier } = fqa.product[item.product_type]
    const quantity = parseInt(item.quantity, 10)
    const lineItemProps = item.properties
    const correctLineItemProps = generateLineItemPropertyFromValue(
      quantity / multiplier
    )

    if (lineItemProps["Cut Length"] !== correctLineItemProps) {
      // Set LIPS to correct value to be updated in queue
      lineItemProps["Cut Length"] = correctLineItemProps
      return {
        key: item.key,
        quantity,
        properties: lineItemProps,
      }
    }
  }
  return null
}

const getCartItemsLineItemPropertiesUpdates = (items, nextLocation) => {
  let hasChange = false
  items.forEach((item) => {
    const change = checkItemProperties(item)
    if (change) {
      hasChange = true
      pushItemToQueue(change, nextLocation, moveAlong)
    }
  })
  return hasChange
}

const checkout = (event) => {
  const items = getItemsFrom(event.target.closest(formSelector))
  const note = getNoteFrom(event.target.closest(formSelector))
  const updates = checkForUpdates(items, note, "checkout")

  if (updates === "cancel") {
    // reload based on confirm prompt
  }
  if (updates) {
    moveAlong()
  } else {
    console.log("no changes go to checkout")
    goToCheckout()
  }
}

const checkoutFromAnyPage = () => {
  // Exported Checkout Function
  // Used when <a href="/checkout"
  // Replaced with <button onclick="FabricShop.checkout()"
  // Notes will not be updated from this function
  const cart = getLocalStorageCart()
  const { items } = cart

  const updates = getCartItemsLineItemPropertiesUpdates(items, "checkout")

  console.log(items, updates)

  if (updates) {
    moveAlong()
  } else {
    console.log("no changes go to checkout")
    goToCheckout()
  }
}

const update = (event) => {
  const items = getItemsFrom(event.target.closest(formSelector))
  const note = getNoteFrom(event.target.closest(formSelector))

  const updates = checkForUpdates(items, note, "reload")

  if (updates) {
    moveAlong()
  } else {
    reload()
  }
}

const disableButtons = () => {
  disable(buttonSelectors)
}

const enableButtons = () => {
  enable(buttonSelectors)
}

const enableUpdateAndCheckoutButtons = () => {
  document.querySelectorAll(`${buttonSelectors}`).forEach((el) => {
    // [Update] - must be disabled until our JS is fully loaded, otherwise the onClick Event Handler will not be initialized and it may update incorrectly
    // [Checkout] - must be disabled until our JS is fully loaded, otherwise the onClick Event Handler will not be initialized and we may miss some LIPS

    if (!el.disabled) {
      // console.error("Disable Element in Liquid", el)
    }
    el.disabled = false
  })
}

export default {
  updateSelectors,
  checkoutSelectors,
  buttonSelectors,
  formSelector,
  update,
  checkout,
  disableButtons,
  enableButtons,
  enableUpdateAndCheckoutButtons,
  checkoutFromAnyPage,
}
